import React, { useRef, useCallback } from "react";
import { Spin } from "antd";
import AuditTrail, { AuditItem } from "./audit-trail";

interface InfiniteAuditTrailProps {
  items: AuditItem[];
  loading: boolean;
  hasMore: boolean;
  initialLoading: boolean;
  onLoadMore: () => void;
  transformItemDisplay?: (item: AuditItem, change: { field: string; from: string; to: string }) => React.ReactNode;
}

const InfiniteAuditTrail: React.FC<InfiniteAuditTrailProps> = ({
  items,
  loading,
  hasMore,
  initialLoading,
  onLoadMore,
  transformItemDisplay,
}) => {
  const observer = useRef<IntersectionObserver | null>(null);

  const lastElementRef = useCallback(
    (node: HTMLDivElement | null) => {
      if (!hasMore) return;
      if (observer.current) observer.current.disconnect();

      observer.current = new IntersectionObserver(
        entries => {
          if (entries[0].isIntersecting && hasMore) {
            onLoadMore();
          }
        },
        { root: null, rootMargin: "0px 0px 200px 0px", threshold: 0 }
      );

      if (node) observer.current.observe(node);
    },
    [hasMore, onLoadMore]
  );

  return (
    <>
      <AuditTrail items={items} transformItemDisplay={transformItemDisplay} />
      {loading && (
        <div style={{ textAlign: "center", padding: 12 }}>
          <Spin />
        </div>
      )}
      {!hasMore && items.length > 0 && (
        <p style={{ textAlign: "center", color: "#999" }}>No more data</p>
      )}
      {/* sentinel */}
      <div ref={lastElementRef} style={{ height: 1 }} />
    </>
  );
};

export default InfiniteAuditTrail;
